// JournalArticleForm migration: 2. XML export — remove unused import
import {
  ContentRegistrationType,
  RecordOrigin,
  UserInfo,
  XMLGenerationStrategy,
} from '@/common/types';
import { GrantXmlRenderingStrategy } from './grant';
import { FormData } from '@content-registration/types';
import { NotImplementedRenderingStrategy } from './not-implemented';
import { JournalArticleXmlRenderingStrategy } from './journal-article';
import { BookXmlRenderingStrategy } from './book';
import { PostPublicationUpdateXmlRenderingStrategy } from './post-publication-update';
import { ConferenceProceedingXmlRenderingStrategy } from './conference-proceeding';
import { ReportXmlRenderingStrategy } from './report';
import { DissertationXmlRenderingStrategy } from './dissertation';

/** Generates XML from form data using strategy pattern based on content type. */
export class XMLRenderingService {
  static async generateXML(
    recordType: ContentRegistrationType = ContentRegistrationType.JournalArticle,
    formData: FormData,
    prettyPrint = false,
    userInfo?: UserInfo,
    origin?: RecordOrigin
  ): Promise<string> {
    let strategy: XMLGenerationStrategy;

    switch (recordType) {
      case ContentRegistrationType.Grant:
        strategy = new GrantXmlRenderingStrategy();
        break;
      case ContentRegistrationType.JournalArticle:
        strategy = new JournalArticleXmlRenderingStrategy();
        break;
      case ContentRegistrationType.Book:
        strategy = new BookXmlRenderingStrategy();
        break;
      case ContentRegistrationType.PostPublicationUpdate:
        strategy = new PostPublicationUpdateXmlRenderingStrategy();
        break;
      case ContentRegistrationType.ConferenceProceeding:
        strategy = new ConferenceProceedingXmlRenderingStrategy();
        break;
      case ContentRegistrationType.Report:
        strategy = new ReportXmlRenderingStrategy();
        break;
      case ContentRegistrationType.Dissertation:
        strategy = new DissertationXmlRenderingStrategy();
        break;
      default:
        throw new Error('Unknown record type');
    }

    return strategy.generateXML(
      recordType,
      formData || {},
      prettyPrint,
      userInfo,
      origin
    );
  }
}
